/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch } from './FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch';
import {
    FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSON,
    FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSONTyped,
    FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSON,
    FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSONTyped,
} from './FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse
 */
export interface FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse {
    /**
     * 
     * @type {Array<FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch>}
     * @memberof FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse
     */
    Branches: Array<FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch>;
}

/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse(value: object): value is FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse {
    if (!('Branches' in value) || value['Branches'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseFromJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse {
    return FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Branches': ((json['Branches'] as Array<any>).map(FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSON)),
    };
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseToJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse {
    return FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponseToJSONTyped(value?: FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Branches': ((value['Branches'] as Array<any>).map(FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSON)),
    };
}

